import * as Cesium from "cesium";

export const getTilesetHeightOffsetMatrix = (
  tileset: Cesium.Cesium3DTileset,
  offsetMm: number,
): Cesium.Matrix4 => {
  const carto = Cesium.Cartographic.fromCartesian(
    tileset.boundingSphere.center,
  );
  const surface = Cesium.Cartesian3.fromRadians(
    carto.longitude,
    carto.latitude,
    0.0,
  );
  const off = Cesium.Cartesian3.fromRadians(
    carto.longitude,
    carto.latitude,
    offsetMm / 1000,
  );
  const translation = Cesium.Cartesian3.subtract(
    off,
    surface,
    new Cesium.Cartesian3(),
  );
  return Cesium.Matrix4.fromTranslation(translation);
};
